import BaseStore from 'vendor/cnpm/fluxible.v0-4/addons/BaseStore';

import NotesSettingsConstants from 'bundles/account-settings/constants/NotesSettingsConstants';
import { UpdateStates } from 'bundles/account-settings/constants/SettingsConstants';
import type { Settings } from 'bundles/account-settings/types/NotesSettings';

class HighlightSettingsStore extends BaseStore {
  static storeName = 'HighlightSettingsStore';

  declare updateStatus: string;

  declare loaded: boolean;

  declare disableDataAggregation: boolean;

  declare disableTopHighlightsDisplay: boolean;

  declare emitChange: () => void;

  static handlers = {
    LOAD_HIGHLIGHT_SETTINGS: 'onLoadHighlightSettings',
    UPDATE_HIGHLIGHT_SETTINGS: 'onUpdateHighlightSettings',
    SET_UPDATE_STATUS: 'onSetUpdateStatus',
  };

  onLoadHighlightSettings({ settings }: { settings: Settings }) {
    this.updateValues(settings);
    this.loaded = true;
    this.emitChange();
  }

  onUpdateHighlightSettings({ settings }: { settings: Settings }) {
    this.updateValues(settings);
    this.updateStatus = UpdateStates.SUCCEEDED;

    const updateStatusTimeout = setTimeout(() => {
      this.updateStatus = UpdateStates.IDLE;
      clearTimeout(updateStatusTimeout);
      this.emitChange();
    }, 5000);

    this.emitChange();
  }

  onSetUpdateStatus({ updateStatus }: { updateStatus: string }) {
    this.updateStatus = updateStatus;
    this.emitChange();
  }

  constructor(dispatcher: any) {
    super(dispatcher);

    this.updateStatus = UpdateStates.IDLE;
  }

  hasLoaded() {
    return this.loaded;
  }

  updateValues(settings: Settings) {
    const { disableDataAggregation, disableDisplay } = settings;

    if (
      disableDataAggregation.includes(NotesSettingsConstants.disableDataAggregation.VIDEO_NOTE_PROPERTIES) &&
      disableDataAggregation.includes(NotesSettingsConstants.disableDataAggregation.NOTE_TEXT)
    ) {
      this.disableDataAggregation = true;
    } else {
      this.disableDataAggregation = false;
    }

    if (disableDisplay.includes(NotesSettingsConstants.disableTopHighlightsDisplay.POPULAR_HIGHLIGHTS)) {
      this.disableTopHighlightsDisplay = true;
    } else {
      this.disableTopHighlightsDisplay = false;
    }
  }

  getDisableDataAggregation() {
    return this.disableDataAggregation;
  }

  getDisableTopHighlightsDisplay() {
    return this.disableTopHighlightsDisplay;
  }

  getUpdateStatus() {
    return this.updateStatus;
  }
}

export default HighlightSettingsStore;
